import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ProgramDto, ProgramFundingListItemDto, PlanData, RetailerLookupDto, StrategicBusinessInitiativeLookupDto, BrandLookupDto, BudgetYearLookupDto, SaveProgramCommand, ProgramId } from 'app/client-core/dtos/programs.model';
import { RetailerService } from 'app/client-core/services/retailer.service';
import { ProgramService } from 'app/client-core/services/program.service';
import { Observable, Subscription } from 'rxjs';
import { ValidationMessage } from 'app/validation';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { ApiResponse } from 'app/client-core/api-response-models';
import { Router } from '@angular/router';
import { BudgetYearTypeaheadComponent, StrategicBusinessInitiativesTypeaheadComponent, RetailersTypeaheadComponent } from '../typeahead';
import { BasicTypeaheadComponent } from '../typeahead/typeaheads/tactics/basic-typeahead.component';
import { CampaignThemeDto } from 'app/client-core/dtos/campaigns.model';
import { CampaignService } from 'app/client-core/services/campaign.service';
import { LayoutService } from '../layout/layout.service';
import { UserService } from 'app/client-core/services/user.service';
import { CierantTypeaheadComponent } from '../components/cierant-typeahead/cierant-typeahead.component';
import { ClientSettingsService } from 'app/client-core/services/client-settings.service';
import { JobsToBeDoneDetailsComponent } from '../components/jobs-to-be-done-details/jobs-to-be-done-details.component';
import { NotificationService } from '../utils/notification.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { DeliveryInformationComponent } from '../delivery-information/delivery-information.component';
import { DeliveryInformationFinalizeComponent } from '../components/delivery-information/delivery-information.component';
import { DropDownDisplayOption, DropDownItem } from 'app/client-core/dtos/dropdown.models';

@Component({
  selector: 'app-create-campaign-modal',
  templateUrl: './create-campaign-modal.component.html',
  styleUrls: ['./create-campaign-modal.component.scss']
})
export class CreateCampaignModalComponent implements OnInit, OnChanges {
  @ViewChild('budgetYearTypeahead') budgetYearTypeahead: CierantTypeaheadComponent;
  @ViewChild('retailerTypeahead') retailerTypeahead: CierantTypeaheadComponent;
  @ViewChild('jobsToBeDone') jobsToBeDone: JobsToBeDoneDetailsComponent;
  @ViewChild('deliveryInformation') deliveryInformation: DeliveryInformationComponent;
  @ViewChild('deliveryInformationComponent') deliveryInformationComponent: DeliveryInformationFinalizeComponent;

  shouldShowJobsToBeDone: boolean;
  activeTab = 'setup';
  ready = true;
  programDto: ProgramDto = {} as ProgramDto;
  submitted: boolean;
  @Input() hideStoreSelector = false;
  itemObjectsLeft: ProgramFundingListItemDto[] = [];
  showRetailerTooltip: boolean;
  showBudgetTooltip: boolean;
  @Input() fromMyCampaigns: boolean;
  @Input() fromProgramOverview: boolean;
  @Input() copy: boolean;
  @Input() programId: number;
  deliveryInformationType: string;
  contactType: string = "OwnerResident";
  recipient: string = "SingleRecipient";
  recipients = [
    {
      title: 'Official Owners and CoOwners',
      value: 'PrimaryOwner',
      selected: false
    },
    {
      title: 'UnOfficial Owners',
      value: 'SecondaryOwner',
      selected: false
    },
    {
      title: 'Residents',
      value: 'Residents',
      selected: false
    },
    {
      title: 'Renters',
      value: 'Renters',
      selected: false
    }
  ]

  recipients2 = [
    {
      title: 'Suppress Units Opted In to Email',
      value: 'SupressEmailContacts',
      selected: false
    },
    {
      title: 'Single Letter Per Unit',
      value: 'DistinctPerUnit',
      selected: false
    }
  ]

  hoveringRetailerTooltip: boolean;
  hoveringBudgetTooltip: boolean;

  extraQueryParams = {};
  stores: Array<any> = [];
  shouldShowStoreField = false;
  allBrands: PlanData[] = [];
  allBrandsSelected: PlanData[] = [];
  retailer: any;
  showCreateCampaignInfoSubscription: any;
  campaignDto: CampaignThemeDto;
  brandFilter: string;
  campaignLoaded: boolean;
  showJobsToBedone: boolean;
  unit: string;
  secondaryContactType: string;
  loadUnitsSubscription: Subscription;
  getCampaignThemeSubscription: Subscription;
  getProgramSubscription: Subscription;
  search: string;
  shippingLocationUpdatedSubscription: Subscription;
  filters: DropDownItem[];
  oldFilters: DropDownItem[];
  selectedFilters: { filterId: any; filterValue: any }[] = [];
  loadingCampaignDto = true;

  moveToSelected(item: ProgramFundingListItemDto) {
    item.markedForDeletion = false;
    this.itemObjectsLeft = [...this.itemObjectsLeft.filter(my => my.jobsToBeDoneHeaderId != item.jobsToBeDoneHeaderId)];
    const index = this.programDto.programFunding.findIndex((my) => {
      return my.jobsToBeDoneHeaderId == item.jobsToBeDoneHeaderId
    });

    if (index == -1) {
      this.programDto.programFunding.push(item);
      this.programDto.programFunding = [...this.programDto.programFunding];
    } else {
      this.programDto.programFunding[index].markedForDeletion = false;
    }
  }

  moveToUnselected(item: ProgramFundingListItemDto) {
    item.markedForDeletion = true;
    this.programDto.programFunding = [...this.programDto.programFunding];

    const index = this.itemObjectsLeft.findIndex((my) => {
      return my.jobsToBeDoneHeaderId == item.jobsToBeDoneHeaderId
    });

    if (index == -1) {
      this.itemObjectsLeft.push(item);
      this.itemObjectsLeft = [...this.itemObjectsLeft];
    }
  }

  selectBrand(brand: PlanData, atl?: number, btl?: number) {
    this.allBrands.find(b => b.brandId == brand.brandId).selected = true;
    if (!this.allBrandsSelected.find(b => b.brandId == brand.brandId)) {
      this.allBrandsSelected.push({
        ...brand,
        selected: true,
        atlTarget: atl,
        btlTarget: btl
      });
    } else {
      this.allBrandsSelected.find(b => b.brandId == brand.brandId).selected = true;
    }
    this.loadDetails();
  }

  unselectBrand(brand: PlanData, fundingId?: number, name?) {
    this.notificationService.smartMessageBox({
      title: "",
      content: `Are you sure you want to delete the funding source, ${name}, from this program?`,
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
      if (ButtonPressed == "Yes") {
        this.deselectBrand(brand);
      }
    });
  }

  deselectBrand(brand) {
    this.allBrandsSelected = this.allBrandsSelected.filter(b => b.brandId != brand.brandId);
    this.allBrandsSelected.push({
      ...brand,
      selected: false
    });
    this.allBrands = this.allBrands.filter(b => b.brandId != brand.brandId);
    this.allBrands.push({
      ...brand,
      selected: false
    });
    this.loadDetails();
  }

  deleteFundingSource(fundingId, brand) {
    this.programService.removeFundingSource(fundingId).subscribe(res => {
      console.log(res);
      this.deselectBrand(brand);
    }, error => {
      this.validationMessages = new ValidationMessage(null, true, "Can't delete program funding").isDanger();
    });
  }

  leftBrands() {
    if (!this.brandFilter) {
      return this.allBrands.filter(b => !b.selected)
    }
    return this.allBrands.filter(b => !b.selected && b.brandName.toLocaleLowerCase().indexOf(this.brandFilter.toLocaleLowerCase()) > -1);
  }

  rightBrands() {
    return this.allBrandsSelected.filter(b => b.selected)
  }

  getDate(val: any): Date {
    if (!val)
      return null;

    return new Date(val);
  }

  //this is assigned by the opener if it is an edit
  @Input() selectedCampaignId?: number;

  @Input()
  selectedProgramId?: number;

  @Input()
  retailerId: number;

  @Input()
  retailerName: string;

  @Input()
  budgetYear: number;

  @Input()
  goToProgramDetails: boolean;

  retailers: Observable<Array<RetailerLookupDto>>;
  units: any[];
  searchableconfig = {
    searchableField: "name",
    titleField: "name"
  }
  strategicBusinessInitiatives: Observable<Array<StrategicBusinessInitiativeLookupDto>>;
  brands: Array<BrandLookupDto>;
  budgetYears: Observable<Array<BudgetYearLookupDto>>;
  filter: string;

  public validationMessages: ValidationMessage;

  isValid: boolean = false;

  onAfterValidate(isValid: boolean): void {
    console.log('>>IsValid', isValid);
    if (!isValid)
      return;

    this.onSubmit();
  }

  validatorOptions = {
    //container: '#messages',
    message: "Field is invalid",
    feedbackIcons: {
      valid: 'fa fa-check',
      invalid: 'fa fa-times',
      validating: 'fa fa-refresh'
    },
    fields: {

    }
  };

  @ViewChild('strategicBusiness') strategicBusiness: StrategicBusinessInitiativesTypeaheadComponent;
  @ViewChild('storeTypeahead') storeTypeahead: BasicTypeaheadComponent;
  retailerextraQueryParams = {};

  columns = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "retailerName", name: "Name", flexGrow: 3 },
  ]);

  columnsStore = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "name", name: "Name", flexGrow: 3 },
  ]);

  columnsFiscalYear = Observable.of([
    { prop: "fiscalYear", name: "Fiscal Year", flexGrow: 3 },
  ]);

  columnsBusinnesInitiative = Observable.of([
    { prop: "id", name: "Id", flexGrow: 1 },
    { prop: "name", name: "Name", flexGrow: 3 },
  ]);

  items: Array<any> = [];

  constructor(
    private layoutService: LayoutService,
    private programService: ProgramService,
    private retailerService: RetailerService,
    private router: Router,
    private campaignService: CampaignService,
    public userService: UserService,
    private clientSettingsService: ClientSettingsService,
    private notificationService: NotificationService
  ) {
  }

  clear() {
    return new Promise((resolve, reject) => {
      if (this.loadUnitsSubscription) {
        this.loadUnitsSubscription.unsubscribe();
      }

      if (this.getProgramSubscription) {
        this.getProgramSubscription.unsubscribe();
      }

      if (this.getCampaignThemeSubscription) {
        this.getCampaignThemeSubscription.unsubscribe();
      }

      if (this.showCreateCampaignInfoSubscription) {
        this.showCreateCampaignInfoSubscription.unsubscribe();
      }
      this.loadingCampaignDto = true;
      this.programId = null;
      this.submitted = false;
      this.programDto = null;
      this.retailer = null;
      this.budgetYear = null;
      this.stores = [];
      this.allBrandsSelected = [];
      this.shouldShowStoreField = false;
      this.allBrands = [];
      this.campaignLoaded = false;
      this.shouldShowJobsToBeDone = false;
      CierantTypeaheadComponent.clearTextEvent.next("budgetTypeahead");
      CierantTypeaheadComponent.clearTextEvent.next("retailerTypeahead");
      if (this.strategicBusiness) {
        this.strategicBusiness.clearText();
      }
      if (this.retailerTypeahead) {
        this.retailerTypeahead.clearText();
      }
      if (this.storeTypeahead) {
        this.storeTypeahead.clearText();
      }
      this.campaignDto = null;
      this.programDto = new ProgramDto();
      this.selectedCampaignId = null;
      this.selectedProgramId = null;
      this.units = [];
      // this.loadCampaignTheme();
      // this.loadProgram();
      resolve(true);
    })
  }

  ngOnInit() {
    this.filter = '';
    this.isValid = false;
    this.programDto.campaignThemeId = this.selectedCampaignId;
    this.programDto.statusId = 10;
    // this.loadCampaignTheme();
    // this.loadProgram();

    if (this.goToProgramDetails) {
      this.retailerService.getRetailer(this.retailerId).subscribe(response => {
        this.retailer = response.data;
      });
      this.programDto = new ProgramDto();
      this.programDto.retailerId = this.retailerId;
      this.programDto.fiscalYear = this.budgetYear;
      this.programDto.statusId = 10;

      this.extraQueryParams = {
        retailerId: this.programDto.retailerId || this.retailerId
      }
      this.loadBrands();
    }

    this.shippingLocationUpdatedSubscription = this.programService.shippingLocationUpdated.subscribe(res => {
      this.loadDeliveryLocations(this.contactType);
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.clear();
    // this.loadCampaignTheme(null);
    // this.loadProgram();
  }

  initialLoad() {
    this.programDto.fiscalYear = this.budgetYear;
    if (this.retailerId || this.programDto.retailerId) {
      this.extraQueryParams = {
        retailerId: this.programDto.retailerId || this.retailerId
      }

      this.retailerService.getAccountLocations({
        retailerId: this.programDto.retailerId || this.retailerId
      }).subscribe(response => {
        if (!response.hasError) {
          if (response.data && response.data.items && response.data.items.length > 0) {
            this.shouldShowStoreField = true;
          } else {
            this.shouldShowStoreField = false;
          }
        }
      });
    }
  }

  closeModal() {
    this.clear();
    this.layoutService.hideSideModal.next();
  }

  onRetailersTypeaheadSelected($event: TypeaheadMatch): void {
    if ($event && $event.item.retailerId) {
      this.programDto.retailerId = +$event.item.retailerId;
      this.extraQueryParams = {
        retailerId: this.programDto.retailerId
      }
      this.retailerService.getAccountLocations({
        retailerId: this.programDto.retailerId
      }).subscribe(response => {
        if (!response.hasError) {
          if (response.data && response.data.items && response.data.items.length > 0) {
            this.shouldShowStoreField = true;
          } else {
            this.shouldShowStoreField = false;
          }
        }
      });
    }

    this.loadBrands();
    console.log('<<added program retailer', this.programDto.retailerId);
  }

  onStrategicBusinessInitiativesTypeaheadSelected(event): void {
    if (event && event.id)
      this.programDto.strategicBusinessInitiativeId = event.id;
  }

  onBudgetYearTypeaheadSelected(event): void {
    if (event && event.fiscalYear) {
      this.programDto.fiscalYear = event.fiscalYear;
      this.retailerextraQueryParams = {
        budgetYear: event.fiscalYear,
        callType: 2
      }
    }
    this.loadBrands();
  }

  changeTheme() {
    if (this.selectedProgramId) {
      this.router.navigateByUrl(`/campaign-library/${this.selectedProgramId}`);
    }
  }

  loadBrands(): void {
    if (!this.programDto.retailerId && !this.retailerId) {
      return;
    }
    this.retailerService.getRetailerBudgetYearBrands(this.programDto.retailerId || this.retailerId, this.programDto.fiscalYear || this.budgetYear, {})
      .subscribe(res => {
        if (!res.hasError) {
          this.allBrands = res.data;
          this.filterBrands();
          this.ready = true;
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Brands could not be retrieved");
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
        },
        () => {
        });
  }

  filterBrands() {
    if (this.programDto.programFunding) {
      this.programDto.fundingSources.forEach(item => {
        const selectedBrand = this.allBrands.find(b => b.jobsToBeDoneHeaderId == item.jobsToBeDoneHeaderId);
        if (selectedBrand) {
          this.selectBrand(selectedBrand, item.estimatedAtl, item.estimatedBtl);
        }
      })
    }
  }

  loadDropdownOptions() {
    this.programService.getDropdownFilters((this.programId || this.selectedProgramId) || 0, (this.campaignDto ? this.campaignDto.id : null) || this.selectedCampaignId, this.retailerId).subscribe(res => {
      this.filters = res.data.items.map(f => new DropDownItem(f));
      this.oldFilters = res.data.items.map(f => new DropDownItem(f));
    });
  }

  loadProgram(programID?): void {
    this.loadDropdownOptions();
    if (this.programDto != null && (programID == this.programDto.id || this.selectedProgramId == this.programDto.id)) {
      return;
    }

    if (!this.selectedProgramId) {
      this.ready = true;
      return;
    }

    this.getProgramSubscription = this.programService.getProgram(programID || this.selectedProgramId)
      .subscribe(res => {
        if (!res.hasError) {
          this.retailerName = res.data.retailerName;
          this.initialLoad();
          this.programDto = ProgramDto.fixDates(res.data);
          this.loadCampaignTheme(this.programDto.campaignThemeId);
          if (this.programDto.fiscalYear == null) {
            var date = new Date();
            this.programDto.fiscalYear = new Date().getFullYear();
          }

          if (this.programDto.retailerId && this.programDto.fiscalYear) {
            this.loadBrands();
          }

          if (this.programDto.campaignThemeTypeId == 3) {
            this.hideStoreSelector = true;
          }

          this.extraQueryParams = {
            retailerId: this.programDto.retailerId
          }

          this.programService.getAccountLocations(this.programDto.id).subscribe(resp => {
            if (resp.data) {
              this.stores = resp.data.data;
              if (this.stores && this.stores.length > 0) {
                this.shouldShowStoreField = true;
              }
            }
            this.ready = true;
          });
          if (this.copy) {
            this.programDto.name = 'Copy of - ' + this.programDto.name;
          }

          this.selectedCampaignId = this.programDto.campaignThemeId;
          this.programDto.retailerName = res.data.retailerName;
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Program could not be retrieved");
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
        },
        () => {
        });
  }

  loadCampaignTheme(campaignThemeId?) {
    this.loadingCampaignDto = true;
    if (!this.selectedCampaignId && !campaignThemeId) {
      this.ready = true;
      this.campaignLoaded = true;
      this.loadingCampaignDto = false;
      return;
    }
    this.getCampaignThemeSubscription = this.campaignService.getCampaignTheme(this.selectedCampaignId || campaignThemeId).subscribe(res => {
      if (!res.hasError) {
        this.campaignDto = res.data;
        if (!this.fromMyCampaigns && this.campaignDto.campaignThemeTypeID == 4) {
          setTimeout(() => {
            this.deliveryInformationComponent.showDeliveryInformation('address_book');
          }, 300);
        }
      }
      setTimeout(() => {
        this.loadingCampaignDto = false;
      }, 200);
      this.campaignLoaded = true;
    })
  }

  async onSubmit(): Promise<void> {
    this.deliveryInformationType = 'address_book'
    this.submitted = false;

    if (this.campaignDto && this.campaignDto.campaignThemeTypeID == 4) {
      if (!this.canSubmit()) {
        this.validationMessages = new ValidationMessage(null, true, "There are some validation errors.");
        this.submitted = true;
        return;
      }
    } else {
      if (!this.canSubmit() || (this.jobsToBeDone && !this.jobsToBeDone.isDetailsValid())) {
        this.validationMessages = new ValidationMessage(null, true, "There are some validation errors.");
        this.submitted = true;
        return;
      }
    }

    if (this.deliveryInformation) {
      this.deliveryInformation.submited = false;
      if (this.deliveryInformationType == 'address_book') {

      } else if (this.deliveryInformationType == 'create-locations') {

      } else if (this.deliveryInformationType == 'import-locations') {

      }
    }

    const selectedFilters = [];
    if (this.filters) {
      this.filters.forEach(filter => {
        filter.displayOptions.forEach(displayOption => {
          if (displayOption.selected) {
            selectedFilters.push({
              parameter: displayOption.parameter,
              value: displayOption.name
            })
          }
        });
      });
    }

    this.programDto.campaignThemeId = this.selectedCampaignId;
    const command: SaveProgramCommand = new SaveProgramCommand();
    command.program = this.programDto;
    command.program.campaignThemeId = this.selectedCampaignId;
    command.program.selectedFundings = this.allBrandsSelected.filter(f => f.selected);
    command.program.fundingSources = this.allBrandsSelected.filter(f => f.selected);

    if (this.stores && this.stores.length > 0) {
      command.accountLocations = this.stores.map(s => s.id);
    } else {
      command.accountLocations = [];
    }

    let isCreate: boolean = false;
    let observe: Observable<ApiResponse<ProgramId>>;
    command.program.campaignThemeId = this.selectedCampaignId;
    command.program.retailerId = this.programDto.retailerId || this.retailerId;
    if (this.campaignDto && this.campaignDto.campaignThemeTypeID == 4) {
      command.program.fiscalYear = moment().toDate().getFullYear();
    }
    if (this.programDto.id) {
      if (this.copy) {
        const id = this.programDto.id;
        delete this.programDto.id;
        observe = this.programService.saveCopy(id, command);
      } else {
        observe = this.programService.updateProgram(this.programDto.id, command);
      }
    }
    else {
      observe = this.programService.createProgram(command);
      isCreate = true;
    }

    this.programDto.accountLocations = this.stores.map(s => {
      return s.id
    });

    this.programDto.campaignThemeId = this.selectedCampaignId;
    observe = this.programService.createNewProgram(this.programDto);
    observe.subscribe(async res => {
      if (!res.hasError) {
        this.programId = res.data.value;
        if (this.deliveryInformation) {
          this.deliveryInformation.selectedProgramId = res.data.value;
          // await this.deliveryInformation.loadProgramDeliveryInformation();
          await this.deliveryInformation.saveDeliveryInformation(res.data.value);
        }

        this.programService.createNewAdditionalPrograms({
          programId: res.data.value,
          perUnit: this.recipients2.find(r => r.value == "DistinctPerUnit").selected ? 1 : 0,
          filters: selectedFilters
        }).subscribe(() => {
          if (!this.programDto.id) {
            this.programDto.id = res.data.value;
          }

          if (this.fromProgramOverview && this.jobsToBeDone) {
            this.jobsToBeDone.save(res.data.value).then(() => {
              this.layoutService.hideSideModal.next();
              this.router.navigateByUrl(`/programdetails/${res.data.value}`);
            });
            return;
          }

          this.validationMessages = new ValidationMessage(null, true, "New program added").isSuccess();
          if (this.fromMyCampaigns || this.selectedProgramId != null) {
            this.campaignService.refreshMyCampaigns.next();
            this.campaignService.programEdited.next();
          } else {
            if (this.goToProgramDetails) {
              this.router.navigateByUrl(`/programdetails/${res.data.value}`);
              this.closeModal();
              return;
            }
            if (isCreate) {
              this.programService.programCreated.next(res.data);
            } else {
              this.programService.programUpdated.next(new ProgramId(this.programDto.id));
            }
          }

          this.programService.newProgramCreated.next(this.programDto)
          this.closeModal();
          this.programDto = new ProgramDto();
          this.campaignDto = new CampaignThemeDto();
          this.clear();
        });
      } else {
        this.validationMessages = new ValidationMessage(res.error, true, "Program could not be saved");
      }
    },
      (err: any) => {
        this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
      },
      () => {
      });
  }

  isRetailersNameValid() {
    if (!this.programDto.retailerId) {
      return false;
    }
    return true;
  }

  isProgramNameValid() {
    return this.programDto.name !== '' && this.programDto.name != null;
  }

  isProgramStartDateValid() {
    return this.programDto.programStartDate !== null && this.programDto.programStartDate !== undefined;
  }

  isDescriptionValid() {
    if (!this.programDto.description) return false;
    return true;
  }

  isProgramEndDateValid() {
    return this.programDto.programEndDate !== null && this.programDto.programEndDate !== undefined;
  }

  isBusinessDriverValid() {
    return this.programDto.strategicBusinessInitiativeId != null && this.programDto.strategicBusinessInitiativeId !== undefined;
  }

  isFiscalYearValid() {
    return this.programDto.fiscalYear != null && this.programDto.fiscalYear !== undefined;
  }

  datesInsideBudgetYearRange() {
    if (!this.programDto.fiscalYear) {
      return true;
    }

    if (this.programDto.programEndDate && moment(this.programDto.programEndDate).toDate().getFullYear() != this.programDto.fiscalYear) {
      return false;
    }

    if (this.programDto.programStartDate && moment(this.programDto.programStartDate).toDate().getFullYear() != this.programDto.fiscalYear) {
      return false;
    }

    return true;
  }

  canSubmit() {
    if (this.campaignDto && this.campaignDto.campaignThemeTypeID == 4) {
      return this.isRetailersNameValid() &&
              this.isStoreValid() &&
              this.areFiltersValid() &&
              this.isAddressSelectionValid() &&
              this.isDeliveryInformationValid();
    } else {
      return this.isRetailersNameValid() &&
        this.isFiscalYearValid() &&
        this.isProgramNameValid() &&
        this.isProgramEndDateValid() &&
        this.isProgramStartDateValid() &&
        this.isStoreValid() &&
        this.isFundingSourceValid() &&
        this.isDescriptionValid() &&
        this.isAddressSelectionValid() &&
        this.isDeliveryInformationValid();
    }
  }

  areFiltersValid() {
    if (!this.filters || this.filters.length == 0) {
      return true;
    }
    return this.filters.filter(f => !f.hasSelectedOption).length === 0
  }

  isStoreValid() {
    if (!this.shouldShowStoreField) {
      return true;
    }
    if (!this.stores || this.stores.length == 0) {
      return false;
    }
    return true;
  }

  canShowBudgetTooltip() {
    return this.hoveringBudgetTooltip && this.programDto.hasProgramTactics;
  }

  onStoreSelected(store) {
    this.stores = [
      store
    ];
    this.loadUnits();
    this.loadDeliveryLocations(this.contactType);
  }

  removeStore(store) {
    this.stores = [];
  }

  sumTotal(item: PlanData) {
    var atl = 0;
    var btl = 0;

    if (item.atlTarget) {
      atl = Number.parseFloat(item.atlTarget.toString().replace(',', ''));
    }

    if (item.btlTarget) {
      btl = Number.parseFloat(item.btlTarget.toString().replace(',', ''));
    }

    return atl + btl;
  }

  sumPrePlan(item: PlanData) {
    var atl = 0;
    var btl = 0;
    if (this.fromProgramOverview) {
      if (item.atlUnplanned) {
        atl = Number.parseFloat(item.atlUnplanned.toString().replace(',', ''));
      }

      if (item.btlUnplanned) {
        btl = Number.parseFloat(item.btlUnplanned.toString().replace(',', ''));
      }
    } else {
      if (item.atlPrePlanRemaining) {
        atl = Number.parseFloat(item.atlPrePlanRemaining.toString().replace(',', ''));
      }

      if (item.btlPrePlanRemaining) {
        btl = Number.parseFloat(item.btlPrePlanRemaining.toString().replace(',', ''));
      }
    }
    return atl + btl;
  }

  loadUnits(searchTerm?) {
    if (this.loadUnitsSubscription) {
      this.loadUnitsSubscription.unsubscribe();
    }
    this.loadUnitsSubscription = this.programService.getUnits({
      programId: this.programId,
      retailerId: this.retailerId,
      contactType: this.contactType,
      accountLocationId: this.stores && this.stores.length ? this.stores[0].id : null,
      openSearch: searchTerm || ''
    }).subscribe(res => {
      this.units = res.data.items
    })
  }

  onRetailerRowSelected(row) {
    if (row && row.id) {
      this.programDto.retailerId = row.id;
      this.extraQueryParams = {
        retailerId: row.id
      }
      this.retailerId = row.id;
      this.retailerService.getAccountLocations({
        retailerId: this.programDto.retailerId
      }).subscribe(response => {
        if (!response.hasError) {
          if (response.data && response.data.items && response.data.items.length > 0) {
            this.shouldShowStoreField = true;
          } else {
            this.shouldShowStoreField = false;
          }
        }
      });
    }

    if (this.deliveryInformationComponent) {
      this.deliveryInformationComponent.loadDeliveryLocationLookup();
    }

    this.loadDeliveryLocations(this.contactType);
    this.loadUnits();

    this.loadBrands();
    this.loadDropdownOptions();
    console.log('<<added program retailer', this.programDto.retailerId);
  }

  loadDeliveryLocations(contactType, selectAll = 0) {
    this.contactType = contactType;
    if (this.deliveryInformation) {
      let accountLocationId: number = null;
      if (this.stores && this.stores.length) {
        accountLocationId = this.stores[this.stores.length - 1].id
      }

      const selectedFilters = {};
      if (this.filters) {
        this.filters.forEach(filter => {
          filter.displayOptions.forEach(displayOption => {
            if (displayOption.selected) {
              selectedFilters[displayOption.parameter] = displayOption.name;
            }
          });
        });
      }

      this.deliveryInformation.loadDeliveryLocationLookup(
        this.programId,
        contactType,
        this.retailerId,
        accountLocationId,
        this.secondaryContactType,
        null,
        this.recipients2.find(r => r.value == "SupressEmailContacts").selected ? 1 : 0,
        this.recipients2.find(r => r.value == "DistinctPerUnit").selected ? 1 : 0,
        this.getSelectedUnits(),
        selectAll,
        selectedFilters
      );
    }
  }

  goToSelectCampaign() {
    this.router.navigateByUrl(`/campaign-library/${this.selectedProgramId}`);
  }

  revise() {
    this.programService.revise(this.selectedProgramId).subscribe(resp => {
      if (!resp.error) {
        this.validationMessages = new ValidationMessage(null, true, "Program revised");
        this.loadProgram();
        this.programService.programUpdated.next();
        this.campaignService.notify.next(this.selectedProgramId);
      }
    });
  }

  getPlaceHolder() {
    if (this.programDto.retailerName || this.retailerName) {
      return this.programDto.retailerName || this.retailerName;
    }

    let label = "Select Retailer";
    if (this.campaignDto && this.campaignDto.campaignThemeTypeID == 4) {
      label = "Property";
    }
    if (this.fromProgramOverview) {
      return this.retailerName;
    }
    if (this.programDto || this.retailer) {
      if (!this.goToProgramDetails) {
        return this.programDto.retailerName || label;
      } else {
        return this.retailer.name || label;
      }
    }
    if (this.programDto != null && this.programDto.retailerName) {
      label = this.programDto.retailerName;
    }
    return label;
  }

  getFiscalYearPlaceHolder() {
    if (this.fromProgramOverview) {
      return this.budgetYear || this.programDto.fiscalYear;
    }

    if (this.programDto.fiscalYear || this.budgetYear) {
      if (!this.goToProgramDetails) {
        return this.programDto.fiscalYear;
      } else {
        return this.budgetYear;
      }
    }
    return 'Select Budget Year';
  }

  isFundingSourceValid() {
    if (!this.fromProgramOverview) {
      return true;
    }

    return this.fromProgramOverview && this.allBrands && this.allBrands.length > 0 && this.rightBrands().length > 0;
  }

  getFundingHeaderIds() {
    if (this.isFundingSourceValid()) {
      return this.rightBrands().map(f => f.jobsToBeDoneHeaderId).join(",");
    }
    return '';
  }

  loadDetails() {
    this.programService.getJobsToBeDoneDetails(this.getFundingHeaderIds(), this.programId).subscribe(res => {
      this.shouldShowJobsToBeDone = res.data.canShow == 1;
    });
  }

  startDateChanged() {
    if (this.programDto.programEndDate && moment(this.programDto.programEndDate).isBefore(moment(this.programDto.programStartDate))) {
      this.programDto.programEndDate = null;
    }
  }

  getMinDate(): Date | null {
    if (!this.programDto.programStartDate) {
      return moment().toDate();
    }
    return moment(this.programDto.programStartDate).toDate();
  }

  onDeliveryLocationTypeChanged(type) {
    this.deliveryInformationType = type;
    if (type == 'address_book') {
      if (this.programId) {
        this.deliveryInformation.loadProgram();
      }
      this.deliveryInformation.loadDeliveryLocationLookup();
    }
  }

  getSelectedUnits() {
    if (this.units && this.units.length) {
      return this.units.filter(u => u.selected).map(u => u.name).join(',')
    }
    return '';
  }

  updateUnits() {
    setTimeout(() => {
      console.log(this.getSelectedUnits());
      this.loadDeliveryLocations(this.contactType);
    }, 400);
  }

  recipientChanged() {
    var secondaryContactType = [];
    this.recipients.forEach(r => {
      if (r.selected) {
        secondaryContactType.push(r.value);
      }
    });
    this.secondaryContactType = secondaryContactType.join(',')
    this.loadDeliveryLocations(this.contactType);
  }

  selectAll() {
    this.loadDeliveryLocations(this.contactType, 1);
  }

  setSelected(items: DropDownDisplayOption[]) {
    if (!items) {
      return;
    }

    const filterId = items[0].filterId;
    if (items.find(i => i.selected) && !this.selectedFilters.find(f => f.filterId == filterId)) {
      this.selectedFilters.push({
        filterId,
        filterValue: items.find(i => i.selected).id
      })
    }

    if (items.find(i => i.selected) && this.selectedFilters.find(f => f.filterId == filterId)) {
      this.selectedFilters = this.selectedFilters.filter(f => f.filterId != filterId);
      this.selectedFilters.push({
        filterId,
        filterValue: items.find(i => i.selected).id
      })
    }

    if (!items.find(f => f.selected)) {
      this.selectedFilters = this.selectedFilters.filter(f => f.filterId != filterId);
    }

    const newFilters: DropDownItem[] = [];
    this.oldFilters.forEach(filter => {
      const selectedParent = this.selectedFilters.find(f => f.filterId == filter.parentFilterId);
      newFilters.push(new DropDownItem({
        ...filter,
        displayOptions: selectedParent ? filter.displayOptions.filter(d => d.parentSelection == selectedParent.filterValue) : filter.displayOptions
      } as DropDownItem));
    });
    this.filters = newFilters;
    this.loadDeliveryLocations(this.contactType);
  }

  isAddressSelectionValid() {
    if (this.deliveryInformation && this.deliveryInformation.itemObjectsRight && this.deliveryInformation.itemObjectsRight.length > 1 && this.recipient == 'SingleRecipient') {
      return false;
    }
    return true;
  }

  isDeliveryInformationValid() {
    if (this.recipient == 'Use Merge Data') {
      return true;
    }
    if (!this.deliveryInformation) {
      return true;
    }

    if (this.deliveryInformation && (!this.deliveryInformation.itemObjectsRight || !Boolean(this.deliveryInformation.itemObjectsRight.length))) {
      return false;
    }
    return true;
  }

  calcZindex(index, total) {
    return total - index;
  }

  verifySelection(selectedValues: string[]) {
    const allRecipients = this.recipients.concat(this.recipients2).filter(r => selectedValues.includes(r.value) && r.selected);
    return allRecipients && allRecipients.length >= selectedValues.length;
      }
}



// WEBPACK FOOTER //
// ./src/app/shared/create-campaign-modal/create-campaign-modal.component.ts